import { render, staticRenderFns } from "./fbpSettings.vue?vue&type=template&id=4543404f&scoped=true"
import script from "./fbpSettings.vue?vue&type=script&lang=js"
export * from "./fbpSettings.vue?vue&type=script&lang=js"
import style0 from "./fbpSettings.vue?vue&type=style&index=0&id=4543404f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4543404f",
  null
  
)

export default component.exports